import React from "react";
import './QuickSearch.css'
const QuickSearch =(props) =>{
    return(
        
        
        <section id="Browse bikes by">
            <h4 class="text-center mt-4 text1"  >Browse bikes by</h4>
            <div class=" Container ">
                <div class="w-75   col1">
                    <div class="card text-center">
                        <div class="card-header">
                            <ul class="nav nav-pills card-header-pills">
                                <li class="nav-item w-25">
                                <a class="nav-link active" href="#">Brand</a>
                                </li>
                                <li class="nav-item w-25">
                                    <a class="nav-link disabled" href="#">Budget</a>
                                </li>
                                <li class="nav-item w-25">
                                    <a class="nav-link disabled" href="#">Mileage</a>
                                </li>
                                <li class="nav-item  w-25">
                                <a class="nav-link disabled" href="#">Body Style
                                </a>
                                </li>
                            
                            </ul>
                        </div>
                        <div class="card-body">
                            <div id="content">
                                <div id="number_container">
                                    <ul>
                                        <li class="selectbrand">
                                            <a href="#tvs">
                                                <span class="brandlogo">
                                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/brandslogo/tvs.webp" alt="TVS bikes"/>
                                                </span>
                                                <span class="brandlogotitle">TVS</span>
                                            </a>
                                        </li>
                                        <li class="selectbrand">
                                            <a href="#bajaj">
                                                <span class="brandlogo">
                                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/brandslogo/bajaj.webp" alt="Bajaj bikes"/>  
                                                </span>
                                                <span class="brandlogotitle">Bajaj</span>
                                            </a>
                                        </li>
                                        <li class="selectbrand">
                                            <a href="#bmw">
                                                <span class="brandlogo">
                                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/brandslogo/bmw.webp" alt="BMW bikes"/>
                                                </span>
                                                <span class="brandlogotitle">BMW</span>
                                            </a>
                                        </li>
                                        <li class="selectbrand">
                                            <a href="#hero">
                                                <span class="brandlogo">
                                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/brandslogo/hero.webp" alt="Hero bikes"/>
                                                </span>
                                                <span class="brandlogotitle">Hero</span>
                                            </a>
                                        </li>
                                        <li class="selectbrand">
                                            <a href="#Honda">
                                                <span class="brandlogo">
                                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/brandslogo/honda.webp" alt="Honda bikes"/>
                                                </span>
                                                <span class="brandlogotitle">Honda</span>
                                            </a>
                                        </li>
                                        <li class="selectbrand">
                                            <a href="#Yezdi">
                                                <span class="brandlogo">
                                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/brandslogo/yezdi.webp" alt="Yezdi bikes"/>
                                                </span>
                                                <span class="brandlogotitle">Yezdi</span>
                                            </a>
                                        </li>
                                        <li class="selectbrand">
                                            <a href="#KTM">
                                                <span class="brandlogo">
                                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/brandslogo/ktm.webp" alt="KTM bikes"/>
                                                </span>
                                                <span class="brandlogotitle">KTM</span>
                                            </a>
                                        </li>
                                        <li class="selectbrand">
                                            <a href="#RoyalEnfield">
                                                <span class="brandlogo">
                                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/brandslogo/royal-enfield.webp" alt="RoyalEnfield bikes"/>
                                                </span>
                                                <span id="brandlogotitle">Royal Enfield</span>
                                            </a>
                                        </li>
                                        <li class="selectbrand">
                                            <a href="#suzuki">
                                                <span class="brandlogo">
                                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/brandslogo/suzuki.webp" alt="suzuki bikes"/>
                                                </span>
                                                <span class="brandlogotitle">Suzuki</span>
                                            </a>
                                        </li>
                                        <li class="selectbrand">
                                            <a href="#Yamaha">
                                                <span class="brandlogo">
                                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/brandslogo/yamaha.webp" alt="Yamaha bikes"/>
                                                </span>
                                                <span class="brandlogotitle">Yamaha</span>
                                            </a>
                                        </li>          
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="d-grid gap-1 col-3 mx-auto w-50">
                            <a href="listpage.html"><button type="button" class="btn btn-outline-warning mb-2 view-all-target-btn">View more Brands</button></a>
                        </div> 
                    </div>
                </div>
            </div>
        </section>
       
       
        
    )
}

export default QuickSearch;